module.exports = __webpack_public_path__ + "static/media/25UNHCR1.43581d3e.jpg";